import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "time-edit-view" }
const _hoisted_2 = { class: "row v-center gap" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "item-box col" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "activity-title large flex spaced" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "row v-center gap spaced" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notify_box = _resolveComponent("notify-box")!
  const _component_si_currency = _resolveComponent("si-currency")!
  const _component_radio_button_group = _resolveComponent("radio-button-group")!
  const _component_progress_button = _resolveComponent("progress-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-button link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'OrderTime' })))
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("div", { class: "gg-close" }, null, -1)
      ])),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "fill row center h2" }, "Refund", -1))
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_notify_box, {
            key: 0,
            type: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.error), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title" }, "A refund is avaliable", -1)),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payments, (payment) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "activity-time flex spaced",
            key: payment.OrderPaymentKey
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createTextVNode(" Amount paid ", -1)),
              (_ctx.isCard(payment.PaymentMethodTypeKey))
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _cache[6] || (_cache[6] = _createTextVNode(" via ", -1)),
                    _createElementVNode("b", null, _toDisplayString(payment.CardBrand) + " *" + _toDisplayString(payment.LastFourDigits), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_si_currency, {
              amount: payment.PaymentAmount ?? 0
            }, null, 8, ["amount"])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "" }, "Refund due", -1)),
          _createVNode(_component_si_currency, {
            amount: Math.abs(_ctx.balance)
          }, null, 8, ["amount"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_radio_button_group, {
        options: _ctx.refundOptions,
        modelValue: _ctx.refundTypeAPI,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.refundTypeAPI) = $event))
      }, null, 8, ["options", "modelValue"])
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        class: "row v-center gray",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1)))
      }, _cache[10] || (_cache[10] = [
        _createElementVNode("span", { class: "gg-chevron-left" }, null, -1),
        _createTextVNode(" Back", -1)
      ])),
      _createVNode(_component_progress_button, {
        showLoader: _ctx.loading,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.makeitsonumberone()))
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode("Complete", -1)
        ])),
        _: 1,
        __: [11]
      }, 8, ["showLoader"])
    ])
  ]))
}